import React from "react";

class GoldenSaleCard extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <a href={`/product/${data.slug}`}>
        <div className={"goldenSaleCard"}>
          <div className={"goldeSaleImg"}>
            <img src={data.image} alt={data.name} />
          </div>
          <div className={"goldenSaleDetails"}>
            <span className={"productName"}>{data.name}</span>
            {data.percent_price < 0 || data.price_percent ? (
              <div className={"productPriceSales"}>
                <div className={"sale"}>
                  <span className={"salePercent"}>{data.percent_price} %</span>
                  <span className={"productPrice"}>
                    {data.min_price?.toLocaleString()}{" "}
                    <span className={"toman"}>تومان</span>
                  </span>
                </div>
                <span className={"productPrice"}>
                  {data.old_price?.toLocaleString()}{" "}
                  <span className={"toman"}>تومان</span>
                </span>
              </div>
            ) : data.min_price === 0 ? (
              <span className={`color-error ${"productPrice"}`}>ناموجود </span>
            ) : (
              <span className={"productPrice"}>
                {data.min_price?.toLocaleString()} تومان{" "}
              </span>
            )}
          </div>
        </div>
      </a>
    );
  }
}

export default GoldenSaleCard;
